/* Waveform grid. One peak pair per device pixel for a sharp, non blocky trace.
   Tap the waveform itself to scrub to that point. Tap anywhere else on the
   card (the name/time footer, or the play icon on demo cards) to just
   toggle play/pause without moving the position. */
(function () {
  var AC = window.AudioContext || window.webkitAudioContext;
  var actx = null;
  var PURPLE = '#b79bff';
  var DIM = 'rgba(183,155,255,0.30)';
  var current = null, audio = null, raf = null;

  function ctxGet() { if (!actx && AC) { actx = new AC(); } return actx; }

  function seeded(str) {
    var h = 1779033703 ^ str.length;
    for (var i = 0; i < str.length; i++) {
      h = Math.imul(h ^ str.charCodeAt(i), 3432918353);
      h = (h << 13) | (h >>> 19);
    }
    return function () {
      h = Math.imul(h ^ (h >>> 16), 2246822507);
      h = Math.imul(h ^ (h >>> 13), 3266489909);
      return ((h ^= h >>> 16) >>> 0) / 4294967296;
    };
  }

  function sizeCanvas(cv) {
    var dpr = window.devicePixelRatio || 1;
    cv.width = Math.round((cv.clientWidth || 300) * dpr);
    cv.height = Math.round((cv.clientHeight || 86) * dpr);
  }

  function peaksFrom(buf, cols) {
    var ch = buf.getChannelData(0), n = ch.length, step = n / cols;
    var out = new Float32Array(cols * 2);
    for (var c = 0; c < cols; c++) {
      var s = Math.floor(c * step), e = Math.floor((c + 1) * step);
      if (e > n) { e = n; }
      if (e <= s) { e = s + 1; }
      var mn = 1.0, mx = -1.0;
      for (var i = s; i < e; i++) { var v = ch[i]; if (v < mn) { mn = v; } if (v > mx) { mx = v; } }
      out[c * 2] = mn; out[c * 2 + 1] = mx;
    }
    return out;
  }

  function fakePeaks(name, cols) {
    var isBeat = /beat|demo|composition/i.test(name || '');
    var rng = seeded(name || 'x');
    var out = new Float32Array(cols * 2);
    var decay = 0.6 + rng() * 2.4;
    var period = Math.max(6, Math.floor(cols / 22));
    for (var c = 0; c < cols; c++) {
      var t = c / cols, a;
      if (isBeat) {
        var body = 0.42 + rng() * 0.22;
        var hit = (c % period < 2) ? 0.34 : 0;
        var fade = t > 0.94 ? (1 - t) / 0.06 : 1;
        a = (body + hit) * fade;
      } else {
        a = Math.pow(1 - t, decay) * (0.35 + rng() * 0.65);
      }
      if (a > 1) { a = 1; }
      out[c * 2] = -a; out[c * 2 + 1] = a;
    }
    return out;
  }

  function draw(card, progress) {
    var cv = card.querySelector('.wf-card__canvas');
    if (!cv || !card._peaks) { return; }
    var g = cv.getContext('2d'), w = cv.width, h = cv.height, mid = h / 2;
    var pk = card._peaks, cols = pk.length / 2;
    var playedTo = progress ? Math.floor(cols * progress) : -1;
    var scale = (h / 2) * 0.92, colW = w / cols;
    g.clearRect(0, 0, w, h);
    for (var c = 0; c < cols; c++) {
      var y1 = mid - pk[c * 2 + 1] * scale, y2 = mid - pk[c * 2] * scale;
      if (y2 - y1 < 1) { y2 = y1 + 1; }
      g.fillStyle = c <= playedTo ? PURPLE : DIM;
      g.fillRect(c * colW, y1, colW, y2 - y1);
    }
    if (playedTo >= 0 && playedTo < cols) {
      g.fillStyle = PURPLE;
      g.fillRect(playedTo * colW, 0, Math.max(colW, 1.5), h);
    }
  }

  function fmt(sec) {
    if (!sec || !isFinite(sec)) { return '0:00'; }
    var m = Math.floor(sec / 60), s = Math.floor(sec % 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  /* Demo play counter. Talks to a small Cloudflare Worker that persists
     counts in KV, keyed by data-track-id. Only wired up for .wf-card--demo
     cards, not the full sound-browser grid. */
  var PLAY_COUNTER_BASE = 'https://demibby-play-counter.demibbycreative.workers.dev';

  function fmtPlays(n) {
    n = n || 0;
    if (n >= 1000000) { return (n / 1000000).toFixed(1).replace(/\.0$/, '') + 'M plays'; }
    if (n >= 1000) { return (n / 1000).toFixed(1).replace(/\.0$/, '') + 'K plays'; }
    return n + (n === 1 ? ' play' : ' plays');
  }

  function loadPlayCount(card) {
    var id = card.getAttribute('data-track-id');
    var el = card.querySelector('[data-plays]');
    if (!id || !el) { return; }
    fetch(PLAY_COUNTER_BASE + '/count?id=' + encodeURIComponent(id))
      .then(function (r) { return r.json(); })
      .then(function (data) { el.textContent = fmtPlays(data.count); })
      .catch(function () {});
  }

  function bumpPlayCount(card) {
    var id = card.getAttribute('data-track-id');
    if (!id) { return; }
    var el = card.querySelector('[data-plays]');
    fetch(PLAY_COUNTER_BASE + '/increment?id=' + encodeURIComponent(id), { method: 'POST' })
      .then(function (r) { return r.json(); })
      .then(function (data) { if (el && typeof data.count === 'number') { el.textContent = fmtPlays(data.count); } })
      .catch(function () {});
  }

  function renderFake(card) {
    var cv = card.querySelector('.wf-card__canvas');
    if (!cv) { return; }
    sizeCanvas(cv);
    card._peaks = fakePeaks(cv.getAttribute('data-fake') || '', Math.max(1, cv.width));
    draw(card, 0);
  }

  function load(card) {
    if (card._loading || card._peaks) { return; }
    card._loading = true;
    var url = card.getAttribute('data-audio-url');
    var cv = card.querySelector('.wf-card__canvas');
    if (!url || !cv) { return; }
    sizeCanvas(cv);
    var cols = Math.max(1, cv.width);
    fetch(url).then(function (r) { return r.arrayBuffer(); }).then(function (ab) {
      var ac = ctxGet();
      if (!ac) { throw new Error('no ctx'); }
      return new Promise(function (res, rej) { ac.decodeAudioData(ab, res, rej); });
    }).then(function (buf) {
      card._peaks = peaksFrom(buf, cols);
      card._dur = buf.duration;
      var t = card.querySelector('.wf-card__time');
      if (t) { t.textContent = fmt(buf.duration); }
      card.classList.add('is-ready');
      draw(card, 0);
    }).catch(function () {
      var nameEl = card.querySelector('.wf-card__name');
      var hint = nameEl ? nameEl.textContent : 'x';
      if (card.classList.contains('wf-card--demo')) { hint = hint + ' beat'; }
      card._peaks = fakePeaks(hint, cols);
      draw(card, 0);
    });
  }

  function stop() {
    if (raf) { cancelAnimationFrame(raf); raf = null; }
    if (audio) { audio.pause(); }
    if (current) { current.classList.remove('is-playing'); current = null; }
  }

  function pause() {
    if (raf) { cancelAnimationFrame(raf); raf = null; }
    if (audio) { audio.pause(); }
    if (current) { current.classList.remove('is-playing'); }
  }

  function tick() {
    if (!current || !audio) { return; }
    var d = audio.duration || current._dur || 0;
    if (d) { draw(current, audio.currentTime / d); }
    raf = requestAnimationFrame(tick);
  }

  function resumeLoop() {
    if (!raf) { raf = requestAnimationFrame(tick); }
  }

  /* Tap the waveform: seeks to that point and ensures playback (used for
     both starting fresh and scrubbing an already-playing card). */
  function seekPlay(card, frac) {
    var url = card.getAttribute('data-audio-url');
    if (!url) { return; }

    if (current === card && audio && audio.src && audio.src.indexOf(url) !== -1) {
      var d = audio.duration || card._dur || 0;
      if (d) { audio.currentTime = frac * d; }
      var p = audio.play();
      if (p && p.catch) { p.catch(function () {}); }
      card.classList.add('is-playing');
      resumeLoop();
      return;
    }

    stop();
    if (!audio) { audio = new Audio(); audio.addEventListener('ended', function () { stop(); }); }
    audio.src = url;
    var startAt = function () {
      var d = audio.duration || 0;
      try { audio.currentTime = frac * d; } catch (e) {}
      var p = audio.play();
      if (p && p.catch) { p.catch(function () {}); }
    };
    if (audio.readyState >= 1) { startAt(); } else { audio.addEventListener('loadedmetadata', startAt, { once: true }); }
    card.classList.add('is-playing');
    current = card;
    resumeLoop();
    if (card.classList.contains('wf-card--demo')) { bumpPlayCount(card); }
  }

  /* Tap anywhere else on the card: plain play/pause toggle, no seeking. */
  function togglePlay(card) {
    var url = card.getAttribute('data-audio-url');
    if (!url) { return; }

    if (current === card && audio) {
      if (audio.paused) {
        var p = audio.play();
        if (p && p.catch) { p.catch(function () {}); }
        card.classList.add('is-playing');
        resumeLoop();
      } else {
        pause();
      }
      return;
    }

    seekPlay(card, 0);
  }

  function fractionFromEvent(el, e) {
    var rect = el.getBoundingClientRect();
    var x = (e.touches && e.touches[0] ? e.touches[0].clientX : e.clientX);
    var f = (x - rect.left) / rect.width;
    if (f < 0) { f = 0; }
    if (f > 1) { f = 1; }
    return f;
  }

  function init() {
    var cards = document.querySelectorAll('.wf-card');
    if (!cards.length) { return; }
    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { load(en.target); io.unobserve(en.target); } });
      }, { rootMargin: '200px' });
    }
    cards.forEach(function (card) {
      var cv = card.querySelector('.wf-card__canvas');
      if (cv && cv.hasAttribute('data-fake')) { renderFake(card); return; }
      if (!card.getAttribute('data-audio-url')) { return; }
      if (card.classList.contains('wf-card--demo')) { loadPlayCount(card); }
      if (io) { io.observe(card); } else { load(card); }

      card.addEventListener('click', function (e) {
        var wave = card.querySelector('.wf-card__cv');
        if (wave && (wave === e.target || wave.contains(e.target))) {
          seekPlay(card, fractionFromEvent(wave, e));
        } else {
          togglePlay(card);
        }
      });
    });
    var rz;
    window.addEventListener('resize', function () {
      clearTimeout(rz);
      rz = setTimeout(function () {
        cards.forEach(function (card) {
          var cv = card.querySelector('.wf-card__canvas');
          if (!cv) { return; }
          if (cv.hasAttribute('data-fake')) { renderFake(card); return; }
          if (card._peaks) { card._peaks = null; card._loading = false; load(card); }
        });
      }, 220);
    });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
